<template>
  <aside
    class="position-fixed h-100 bg-dark shadow-lg px-1 pt-6 pt-md-0 to-front flex-column animate__animated"
    :class="{ 'd-flex': opened, 'animate__slideInLeft': opened, 'animate__slideOutLeft': !opened }"
  >
    <router-link :to="rotaInicial" class="d-none d-md-block py-3 px-1 text-center link-primary">
      <img src="/logo.png" width="38">
    </router-link>
    <ul class="nav nav-pills nav-flush d-flex flex-column text-center mt-2 link-primary">
      <MenuItem v-for="menuItem in menu" v-bind="menuItem" :key="menuItem.title" />
    </ul>
    <AvatarMenu class="mx-auto mt-auto mb-2 d-none d-md-block link-primary" />
  </aside>
</template>

<script>
import MenuItem from '../components/SideBarMenuItem.vue';
import AvatarMenu from '../components/AvatarMenu.vue';
import getMenu from '@/modules/core/security/menuBuilder';

export default {
  components: { AvatarMenu, MenuItem },
  props: {
    isOpen: { type: Boolean, required: true },
  },
  data: () => ({ alwaysOpen: window.innerWidth >= 768, menu: getMenu() }),
  computed: {
    rotaInicial() { return this.menu?.[0]?.submenu?.[0]?.to ?? '/'; },
    opened() { return this.alwaysOpen || this.isOpen; },
  },
  mounted() { window.addEventListener('resize', this.onResize); },
  unmounted() { window.removeEventListener('resize', this.onResize); },
  methods: {
    onResize() { this.alwaysOpen = (window.innerWidth >= 768); },
  },
};
</script>

<style scoped>
.to-front {
  z-index: 1050;
}

.pt-6 {
  padding-top: 60px;
}</style>
